import React from 'react';
import ReactDOM from 'react-dom/client';

import '@fontsource-variable/geist';
import '@fontsource-variable/manrope';
import '@fontsource-variable/plus-jakarta-sans';

import App from './App';
import './lib/i18n';
import './styles/index.css';

const root = document.getElementById('root');
if (!root) throw new Error('Élément #root introuvable');

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
